export default function NotFoundPage() {
    return (
        <h1>404 Not Found</h1>
    )
}